import { gql } from '@apollo/client';

const WHEEL_FORTUNE_EVENT_FRAGMENT = gql`
  fragment WheelFortuneEventConfigFragment on WheelFortuneEventConfig {
    id
    name
    startDate
    stopDate
    spinPrice {
      type
      amount
    }
    spinPricePlus {
      type
      amount
    }
    status
    rewards {
      reward {
        type
        amount
        itemId
      }
      weight
    }
    filterUserIds
    filterSubscriptionTier
    filterUserMinCreationDate
    filterUserMaxCreationDate
    filterAppVersion
    filterUserLevel
  }
`;

export const GET_ALL_WHEEL_FORTUNE_EVENTS = gql`
  query getAllWheelFortuneEvents {
    liveOps {
      getAllWheelFortuneEvents {
        id
        name
        startDate
        stopDate
        status
      }
    }
  }
`;

export const GET_WHEEL_FORTUNE_EVENT = gql`
  query getWheelFortuneEvent($id: ID!) {
    liveOps {
      getWheelFortuneEvent(id: $id) {
        ...WheelFortuneEventConfigFragment
      }
    }
  }
  ${WHEEL_FORTUNE_EVENT_FRAGMENT}
`;

export const CREATE_WHEEL_FORTUNE_EVENT = gql`
  mutation createWheelFortuneEvent($input: CreateWFEventInput!) {
    createWheelFortuneEvent(input: $input) {
      event {
        ...WheelFortuneEventConfigFragment
      }
    }
  }
  ${WHEEL_FORTUNE_EVENT_FRAGMENT}
`;

export const UPDATE_WHEEL_FORTUNE_EVENT = gql`
  mutation updateWheelFortuneEvent($input: UpdateWFEventInput!) {
    updateWheelFortuneEvent(input: $input) {
      event {
        ...WheelFortuneEventConfigFragment
      }
    }
  }
  ${WHEEL_FORTUNE_EVENT_FRAGMENT}
`;

export const DELETE_WHEEL_FORTUNE_EVENT = gql`
  mutation deleteWheelFortuneEvent($id: ID!) {
    deleteWheelFortuneEvent(id: $id)
  }
`;

const WF_REWARD_TEMPLATE_FRAGMENT = gql`
  fragment WheelFortuneRewardTemplateFragment on WheelFortuneRewardTemplate {
    id
    name
    rewards {
      reward {
        type
        amount
        itemId
      }
      weight
    }
  }
`;

export const GET_ALL_WF_REWARD_TEMPLATE = gql`
  query getAllWheelFortuneRewardConfigs {
    liveOps {
      getAllWheelFortuneRewardConfigs {
        ...WheelFortuneRewardTemplateFragment
      }
    }
  }
  ${WF_REWARD_TEMPLATE_FRAGMENT}
`;

export const CREATE_WF_REWARD_TEMPLATE = gql`
  mutation createWFRewardTemplate($input: CreateWFRTemplateInput!) {
    createWFRewardTemplate(input: $input) {
      template {
        ...WheelFortuneRewardTemplateFragment
      }
    }
  }
  ${WF_REWARD_TEMPLATE_FRAGMENT}
`;

export const UPDATE_WF_REWARD_TEMPLATE = gql`
  mutation updateWFRewardTemplate($input: UpdateWFRTemplateInput!) {
    updateWFRewardTemplate(input: $input) {
      template {
        ...WheelFortuneRewardTemplateFragment
      }
    }
  }
  ${WF_REWARD_TEMPLATE_FRAGMENT}
`;

export const DELETE_WF_REWARD_TEMPLATE = gql`
  mutation deleteWFRewardTemplate($id: ID!) {
    deleteWFRewardTemplate(id: $id)
  }
`;